import { deleteHttp } from "../common/api/apiShared.ts";
import { createElement, useState } from "react";
import { Trans } from "react-i18next";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { LegalEntityDeletionResult } from "./deleteLegalEntityBlockedDialog/DeleteLegalEntityBlockedDialog.types.ts";

export type LegalEntityToDelete = {
    legalEntityId: string;
    name: string;
};

export function useDeleteLegalEntity(onLegalEntityDeleted?: () => void) {
    const snackbar = useDotLegalSnackbar();
    const [legalEntityToDelete, setLegalEntityToDelete] = useState<LegalEntityToDelete | undefined>();
    const [blockedDeletion, setBlockedDeletion] = useState<LegalEntityDeletionResult | undefined>();

    const deleteLegalEntityMutation = useDotLegalMutation(deleteLegalEntityApi);
    const deleteLegalEntity = async (legalEntity: LegalEntityToDelete) => {
        await deleteLegalEntityMutation.mutateAsync(legalEntity.legalEntityId, {
            onSuccess: (response: any) => {
                setLegalEntityToDelete(undefined);

                const resp: LegalEntityDeletionResult = response.value();
                if (resp.isDeleted) {
                    snackbar.show(createElement(Trans, { i18nKey: "itemDeletedSuccess", values: { name: legalEntity!.name } }));
                    if (onLegalEntityDeleted) {
                        onLegalEntityDeleted();
                    }
                } else {
                    setBlockedDeletion(resp);
                }
            },
        });
    };

    function deleteLegalEntityApi(legalEntityId: string) {
        return deleteHttp<string>("/legalentity/" + legalEntityId);
    }

    return {
        legalEntityToDelete,
        setLegalEntityToDelete,
        deleteLegalEntity,
        isDeletingLegalEntity: deleteLegalEntityMutation.isLoading,
        blockedDeletion,
        closeBlockedDeletion: () => setBlockedDeletion(undefined),
    };
}
